import React, { Fragment } from 'react';
import {
  Button, Modal, ModalHeader, ModalBody, ModalFooter,
  Col, Form, FormGroup, Label, Input
} from 'reactstrap';
import { withTranslation } from 'react-i18next';

import { createAdmin, updateAdmin } from "../../API/AdminAPI";
import { toast } from 'react-toastify';

class AdminModal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: this.props.open,
      isEdit: this.props.admin && this.props.admin.id ? true : false,
      admin: {
        email: "",
        active: ""
      }
    };

    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    if (this.state.isEdit) {
      const { id, email, active } = this.props.admin;
      this.setState({
        admin: { id, email, active }
      })
    }
  }

  toggle() {
    if (this.state.modal && typeof this.props.onClose === 'function') {
      this.props.onClose(); // call onClose when closing
    }
    this.setState({
      modal: !this.state.modal,
      admin: {
        email: "",
        active: false
      }
    });
  }

  handleChange(event) {
    const key = event.target.name;
    const value = event.target.type === 'checkbox'
      ? event.target.checked : event.target.value;
    this.setState(updater => ({
      admin: {
        ...updater.admin,
        [key]: value
      }
    }));
  }

  submit() {
    const promise = this.state.isEdit ? updateAdmin(this.state.admin) : createAdmin(this.state.admin);
    promise.then(result => {
      if (typeof this.props.onSubmitCallback === 'function') {
        this.props.onSubmitCallback();
        this.toggle();
      }
    }).catch(error => {
      console.error("Error submiting admin", error);
      const messageKey = this.state.isEdit ? 'errors.updating' : 'errors.creating';
      toast["error"](this.props.t(messageKey, { element: 'Admin', message: error.message }));
    });
  }

  render() {
    const { t, i18n } = this.props;

    const openButton = this.props.showOpenButton &&
      <Button className="mb-2 mr-2 btn-icon btn-shadow" size="lg" color="success"
        onClick={() => this.toggle()}>
        <i className="lnr-plus-circle btn-icon-wrapper"> </i>
        {t('admins.actions.create')}
      </Button>;

    const title = this.state.isEdit ? t('admins.actions.edit') : t('admins.actions.create')

    return (
      <Fragment>
        {openButton}
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader toggle={this.toggle}>{title}</ModalHeader>
          <ModalBody>
            <Form onSubmit={(e) => { e.preventDefault(); this.submit(); }}>
              <FormGroup row>
                <Label for="email" sm={2}>{t('admins.email')}</Label>
                <Col sm={10}>
                  <Input type="email" name="email" id="email" readOnly={this.state.isEdit}
                    value={this.state.admin.email} onChange={this.handleChange} />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="active" sm={2}>{t('admins.active')}</Label>
                <Col sm={10}>
                  <Input type="checkbox" name="active" id="active"
                    checked={this.state.admin.active} onChange={this.handleChange}>
                  </Input>
                </Col>
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="link" onClick={this.toggle}>{t('actions.cancel')}</Button>
            <Button color="primary" onClick={this.submit}>{t('actions.submit')}</Button>{' '}
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

AdminModal.defaultProps = {
  open: false,
  showOpenButton: true
}

export default withTranslation()(AdminModal);
